import Repository from '@/libs/axios'

const volumetricWeightSettingResource = '/admin/settings/volumetric-weight'
const volumetricWeightOrderResource = '/admin/order/volumetric-weight'

export default {
  getVolumetricSetting() {
    return Repository.get(`${volumetricWeightSettingResource}`)
  },
  setDefaultVolumetricSetting(payload) {
    return Repository.put(`${volumetricWeightSettingResource}`, payload)
  },
  getVolumetricWeight(payload) {
    return Repository.get(`${volumetricWeightOrderResource}`, {
      params: payload,
    })
  },
}
